import { useDataLoader, AssetStreamsService } from "@xala/common-services";
import { NotificationService } from "@xala/common-ui";
import React from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router";
import { MediaChannelForm } from "..";

const assetStreamsService = new AssetStreamsService().promisify();
const notificationService = NotificationService.getInstance();

export const MediaChannelDetails: React.FC = () => {
  const id = parseInt(useParams<{ id: string }>()["id"]);
  const history = useHistory();
  const { t } = useTranslation();

  const { data, loading, refresh } = useDataLoader({
    loader: () => assetStreamsService.getChannelById(id),
    deps: [id],
    onError: (error) =>
      notificationService.error({
        message: t("LOADING_DATA_ERROR_MESSAGE"),
        description: error.Message,
      }),
  });

  return (
    <MediaChannelForm
      channel={data}
      loading={loading}
      refresh={refresh}
      title={t("MEDIA_CHANNEL_DETAILS_TITLE")}
      userId={data?.AssetId}
      onBack={history.goBack}
    />
  );
};
